/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

const SERVICE_URL = "/api/v1/session/update-csrf-token";
const REQUEST_OPTIONS = {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' }
};
const CSRF_TOKEN_ID = "csrfToken";

export const updateCsrfToken = () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  let tririgaUrl = "";
  if (process.env.NODE_ENV === 'development') {
    tririgaUrl = process.env.REACT_APP_DEV_HOST + SERVICE_URL;
  } else {
    tririgaUrl = "../.." + SERVICE_URL;
  }
  fetch(tririgaUrl, REQUEST_OPTIONS)
    .then((response) => {
      response.json().then(data => {
        localStorage.setItem(CSRF_TOKEN_ID, JSON.stringify(data[CSRF_TOKEN_ID]));
      });
    });
}
